import { useNavigate } from 'react-router-dom';

import { DASHBOARD } from '@constants/routes';
import { LOCAL_STORAGE_KEYS } from '@constants/storage';
import { api } from '@core/baseApi';
import { RootState, useAppDispatch, useAppSelector } from '@core/store';
import { updateBranchFilter } from '@layouts/main-header/branchSlice';
import { TRIAL_BANNER_HEIGHT } from '@layouts/main-layout/constants';
import useTopBannersOffset from '@layouts/main-layout/hooks/useTopBannersOffset';

import { exitTrialMode } from '../slices/trialSlice';

const TrialModeBanner = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isTrialMode = useAppSelector(
    (state: RootState) => state.trial?.isTrialMode
  );
  const originalStorageValues = useAppSelector(
    (state: RootState) => state.trial?.originalStorageValues
  );
  const { sandboxOffset } = useTopBannersOffset();

  const handleExitTrialMode = () => {
    dispatch(
      updateBranchFilter({
        branchId: originalStorageValues?.[LOCAL_STORAGE_KEYS.BRANCH_ID] || '',
        branchName:
          originalStorageValues?.[LOCAL_STORAGE_KEYS.BRANCH_NAME] || ''
      })
    );
    dispatch(exitTrialMode());
    // Force every cached query (user, org, branch, groups, etc.) to refetch
    // against the real account instead of continuing to show demo data.
    dispatch(api.util.resetApiState());
    navigate(DASHBOARD);
  };

  if (!isTrialMode) return null;

  return (
    <div
      className="fixed inset-x-0 z-20 flex items-center justify-between gap-4 bg-cofeeBlue8 px-6"
      style={{ top: sandboxOffset, height: TRIAL_BANNER_HEIGHT }}
    >
      <span className="text-base font-medium text-cofeeNeutral1">
        You&apos;re viewing demo data — none of these figures are real
      </span>
      <button
        type="button"
        onClick={handleExitTrialMode}
        className="shrink-0 rounded-lg bg-cofeeNeutral1 px-4 py-1.5 text-sm font-medium text-cofeeNeutral10 transition-colors hover:bg-cofeeBlue2"
      >
        Exit demo
      </button>
    </div>
  );
};

export default TrialModeBanner;
